(function () {
  var buttonPattern = /\b(pre[\s-]?order|reserve|order\s+now)\b/i;
  var messagePattern = /(shipping|ships).{0,45}(soon|possible|asap|weeks?|2-3|2 to 3)|as soon as possible/i;

  function textFor(element) {
    if (!element) return "";
    return [
      element.value,
      element.getAttribute && element.getAttribute("aria-label"),
      element.getAttribute && element.getAttribute("title"),
      element.textContent
    ].filter(Boolean).join(" ").trim();
  }

  function isClickable(element) {
    if (!element || element.nodeType !== 1) return false;
    var tag = element.tagName;
    return tag === "BUTTON" ||
      tag === "A" ||
      tag === "INPUT" ||
      element.getAttribute("role") === "button";
  }

  function hasMatchingDescendant(element, pattern) {
    return Array.prototype.some.call(element.children || [], function (child) {
      return pattern.test(textFor(child));
    });
  }

  function unmarkStoqElements() {
    document.querySelectorAll(".mf-stoq-preorder-button, .mf-stoq-preorder-message, .mf-stoq-preorder-message-shell, .mf-stoq-preorder-message-outer").forEach(function (element) {
      element.classList.remove("mf-stoq-preorder-button", "mf-stoq-preorder-message", "mf-stoq-preorder-message-shell", "mf-stoq-preorder-message-outer");
    });
  }

  function setImportantStyle(element, styles) {
    Object.keys(styles).forEach(function (property) {
      element.style.setProperty(property, styles[property], "important");
    });
  }

  function setShippingMessage(element) {
    var updatedText = "Ships in approximately 2-3 weeks";
    if (element.tagName === "INPUT") {
      if (element.value === updatedText) return;
      element.value = updatedText;
      return;
    }
    if (element.textContent.trim() === updatedText) return;
    element.textContent = updatedText;
  }

  function styleShippingLayers(messageElement) {
    var shell = messageElement.parentElement;
    var current = shell && shell.parentElement;
    var depth = 0;

    if (shell && !buttonPattern.test(textFor(shell))) {
      shell.classList.add("mf-stoq-preorder-message-shell");
      setImportantStyle(shell, {
        "display": "flex",
        "align-items": "center",
        "justify-content": "center",
        "gap": "10px",
        "width": "min(100%, 390px)",
        "margin": "10px auto 0",
        "padding": "8px 10px",
        "background": "#f0065f",
        "background-color": "#f0065f",
        "border": "0",
        "border-radius": "16px",
        "box-shadow": "none",
        "outline": "0",
        "filter": "none"
      });
    }

    while (current && current !== document.body && depth < 5) {
      if (!buttonPattern.test(textFor(current)) && messagePattern.test(textFor(current))) {
        current.classList.add("mf-stoq-preorder-message-outer");
        setImportantStyle(current, {
        "width": "100%",
        "margin": "0",
        "padding": "0",
        "background": "transparent",
        "background-color": "transparent",
        "border": "0",
        "border-radius": "0",
        "box-shadow": "none",
        "outline": "0",
        "filter": "none"
        });
      }

      current = current.parentElement;
      depth += 1;
    }
  }

  function markStoqElements() {
    unmarkStoqElements();

    document.querySelectorAll('input[name="properties[Shipping]"]').forEach(function (input) {
      input.value = "Ships in approximately 2-3 weeks";
    });

    var candidates = document.querySelectorAll(
      "button, a, input[type='button'], input[type='submit'], [role='button'], [class*='stoq' i], [id*='stoq' i], [class*='preorder' i], [id*='preorder' i], [class*='pre-order' i], [id*='pre-order' i]"
    );

    candidates.forEach(function (element) {
      var text = textFor(element);

      if (isClickable(element) && buttonPattern.test(text)) {
        element.classList.add("mf-stoq-preorder-button");
      }

      if (!isClickable(element) && messagePattern.test(text) && !hasMatchingDescendant(element, messagePattern)) {
        setShippingMessage(element);
        element.classList.add("mf-stoq-preorder-message");
        styleShippingLayers(element);
      }
    });
  }

  markStoqElements();
  window.addEventListener("load", markStoqElements);

  var observer = new MutationObserver(function () {
    window.requestAnimationFrame(markStoqElements);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
